export const clientRouteConfig = {
    searches: {
        path: '/searches',
    },
    searchesNew: {
        path: '/searches-new',
    },
    mappings: {
        path: '/mappings',
    },
}
